export default function reducer(state = {
  sucursalesFG: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_FG": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}